import script from "./contact-messages.vue?vue&type=script&setup=true&lang=js"
export * from "./contact-messages.vue?vue&type=script&setup=true&lang=js"

import "./contact-messages.vue?vue&type=style&index=0&id=737b912d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\dashboard-pro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-737b912d"]])

export default __exports__